import { valorAPesos } from "./formatters";
import { validateMontoTasa } from "./validations";

export const DECLARACION_TEMPLATE_VARIABLES = [
  {
    key: "numero_ddjj",
    token: "{{numero_ddjj}}",
    label: "Número DDJJ",
    description: "Número de la declaración jurada",
  },
  {
    key: "anio",
    token: "{{anio}}",
    label: "Año",
    description: "Año de la declaración jurada",
  },
  {
    key: "razon_social",
    token: "{{razon_social}}",
    label: "Razón social",
    description: "Razón social de la empresa",
  },
  {
    key: "categoria",
    token: "{{categoria}}",
    label: "Categoría",
    description: "Categoría o tasa asignada a la DDJJ",
  },
  {
    key: "monto_tasa",
    token: "{{monto_tasa}}",
    label: "Monto tasa",
    description: "Monto total de la tasa en pesos",
  },
];

export const DEFAULT_DECLARACION_TEMPLATE =
  "Ponemos a su conocimiento que a los fines del cálculo de la tasa anual de control y fiscalización exigida en el Art. Nº 16 de la ley Nº 24.051 y las previsiones del Decreto Nº 2092 MLyRI-2006 y Resolución Nº 08-SCCRP-2006 y teniendo en cuenta la carga online de la DDJJ {{numero_ddjj}} la empresa {{razon_social}} pertenece a la categoría {{categoria}} por la cual deberá abonar un monto igual o equivalente a {{monto_tasa}}. Para efectuar el pago antes descripto, deberá ingresar a la Dirección de Ingresos Públicos. https://dpip.sanluis.gov.ar. Tasas--Tasas Administrativas--Emitir Tasa--Seleccionar Tasa correspondiente.";

const LEGACY_TEMPLATE_PREFIXES = [
  "Ponemos a su conocimiento que a los fines del cálculo de la tasa anual de control y fiscalización exigida en el Art. Nº 16 de la ley Nº 24.051 y las previsiones del Decreto Nº 2092 MLyRI-2006 y Resolución Nº 08-SCCRP-2006",
  "Ponemos a su conocimiento que a los fines del cálculo de la tasa anual de control y fiscalizaciónexigida en el Art. Nº 16 de la ley Nº 24.051 y las previsiones del Decreto Nº 2092 MLyRI-2006 y Resolución Nº 08-SCCRP-2006",
];

const normalizeText = (text = "") =>
  text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

const isLegacyPrefixTemplate = (template = "") => {
  const normalizedTemplate = normalizeText(template);

  return (
    !template.includes("{{") &&
    LEGACY_TEMPLATE_PREFIXES.some(
      (legacyPrefix) => normalizeText(legacyPrefix) === normalizedTemplate
    )
  );
};

export const getDeclaracionTemplate = (template) => {
  const trimmedTemplate = template?.trim();

  if (!trimmedTemplate) {
    return DEFAULT_DECLARACION_TEMPLATE;
  }

  if (isLegacyPrefixTemplate(trimmedTemplate)) {
    return DEFAULT_DECLARACION_TEMPLATE;
  }

  return trimmedTemplate;
};

export const buildDeclaracionTemplateValues = (declaracion) => ({
  numero_ddjj: declaracion?.id || "",
  anio: declaracion?.anio || "",
  razon_social: declaracion?.empresa?.razonSocial || "",
  categoria: declaracion?.tasa || "",
  monto_tasa: validateMontoTasa(declaracion?.montoTasa)
    ? valorAPesos(declaracion.montoTasa)
    : "Monto de tasa inválido",
});

export const resolveDeclaracionTemplate = (template, declaracion) => {
  const values = buildDeclaracionTemplateValues(declaracion);
  const normalizedTemplate = getDeclaracionTemplate(template);

  return normalizedTemplate.replace(/{{\s*([a-z_]+)\s*}}/gi, (match, variableName) => {
    const value = values[variableName.toLowerCase()];

    return value ?? match;
  });
};
